import { render, staticRenderFns } from "./Exams.vue?vue&type=template&id=0fe0a9be&scoped=true"
import script from "./Exams.vue?vue&type=script&lang=js"
export * from "./Exams.vue?vue&type=script&lang=js"
import style0 from "./Exams.vue?vue&type=style&index=0&id=0fe0a9be&prod&scoped=true&lang=css"
import style1 from "./Exams.vue?vue&type=style&index=1&id=0fe0a9be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0a9be",
  null
  
)

export default component.exports